/**
 * VariableChipExtension — TipTap Custom Node fuer Variable-Chips.
 *
 * Ein {{varName}}-Chip ist eine atomare, inline, nicht-editierbare Box. User kann
 * den Chip als Ganzes loeschen, aber nicht "ins Chip hinein" navigieren.
 *
 * renderHTML gibt <span data-variable="varName">{{varName}}</span> aus — das wird
 * in DB als bodyHtml gespeichert und von Backend-renderEmailHtml.applyVars per
 * Regex /\{\{(\w+)\}\}/g korrekt expandiert (siehe Plan 5.2-01).
 */
import { Node } from '@tiptap/core';

export const VariableChipExtension = Node.create({
  name: 'variableChip',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      variableName: { default: '' },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-variable]',
        getAttrs: (dom) => ({
          variableName: (dom as HTMLElement).getAttribute('data-variable') ?? '',
        }),
      },
    ];
  },

  renderHTML({ node }) {
    // Iter 7 (30.05.): KEIN Inline-Style mehr — sonst landet `background:#E9FF57`
    // in der gesendeten Mail und der Empfaenger sieht den Vereinsname gelb
    // hervorgehoben. Editor-Highlighting macht Tailwind via TipTapEditor-CSS:
    // `[&_span[data-variable]]:bg-[#E9FF57]`. Mail-Render-Pfad (renderEmailHtml.ts)
    // strippt den ganzen <span data-variable> via stripVariableChips() vor applyVars.
    return [
      'span',
      {
        'data-variable': node.attrs.variableName,
        contenteditable: 'false',
      },
      `{{${node.attrs.variableName}}}`,
    ];
  },

  renderText({ node }) {
    return `{{${node.attrs.variableName}}}`;
  },
});
